// gerado por work/gerar_pdp.py - nao editar a mao
(function () {
  function ligar() {
    var alvo = document.getElementById('ionix-sg-overlay') || document.querySelector('.ix-pp');
    if (!alvo) return;
    var raiz = alvo.closest('.product-info') || document.body;
    if (raiz.dataset.ewcLigado === '1') return;
    raiz.dataset.ewcLigado = '1';
    /* guia */
    (function () {
      /* ── The factory chart, verbatim. cm and kg, as supplied 2026-09. ──
         Garment columns (waist/hip/thigh/len) are the leggings measured flat,
         per the sheet's own "manual measurement" note. Confirm with factory. */
      var SIZES = [
        { label: 'XS',  wMin: 40,  wMax: 50,  hMin: 155, hMax: 165, len: 78, waist: 27, hip: 31.5, thigh: 30 },
        { label: 'S',   wMin: 50,  wMax: 60,  hMin: 158, hMax: 168, len: 80, waist: 29, hip: 34,   thigh: 34 },
        { label: 'M',   wMin: 60,  wMax: 70,  hMin: 160, hMax: 170, len: 82, waist: 31, hip: 36.5, thigh: 36 },
        { label: 'L',   wMin: 70,  wMax: 80,  hMin: 162, hMax: 172, len: 84, waist: 33, hip: 39,   thigh: 39 },
        { label: 'XL',  wMin: 80,  wMax: 90,  hMin: 165, hMax: 175, len: 86, waist: 35, hip: 41.5, thigh: 41 },
        { label: 'XXL', wMin: 90,  wMax: 100, hMin: 168, hMax: 180, len: 88, waist: 37, hip: 43.5, thigh: 43 },
        { label: 'XXXL',wMin: 100, wMax: 110, hMin: 170, hMax: 182, len: 90, waist: 39, hip: 46,   thigh: 45 },
        { label: '4XL', wMin: 110, wMax: 120, hMin: 172, hMax: 185, len: 91, waist: 41, hip: 48,   thigh: 47 }
      ];

      /* At an exact band boundary (60 kg is both top-of-S and bottom-of-M) which
         size leads. 'larger' reads the factory's ranges as [min, max), the
         standard convention, so 60 kg → M. Nothing brand-side in the match. */
      var BOUNDARY_PREFERS = 'larger';

      var overlay  = document.getElementById('ixsf-overlay');
      var openBtn  = document.getElementById('ixsf-open');
      var closeBtn = document.getElementById('ixsf-close');
      if (!overlay || !openBtn || !closeBtn) return;

      var wIn   = document.getElementById('ixsf-weight');
      var hA    = document.getElementById('ixsf-height-a');
      var hB    = document.getElementById('ixsf-height-b');
      var hRow  = overlay.querySelector('.ixsf-input-row--pair');
      var out   = document.getElementById('ixsf-result');
      var tbody = document.querySelector('#ixsf-table tbody');
      var gbody = document.querySelector('#ixsf-garment-table tbody');
      var unitsEl = document.getElementById('ixsf-units');
      var unit  = 'imperial';

      /* ── Units ─────────────────────────────────────────── */
      function kgToLb(kg) { return Math.round(kg * 2.20462); }
      function cmToFtIn(cm) {
        var totalIn = Math.round(cm / 2.54);
        var ft = Math.floor(totalIn / 12), inch = totalIn % 12;
        return ft + '′' + inch + '″';
      }
      function cmToIn(cm) { return (cm / 2.54).toFixed(1); }
      function fmtWeight(a, b) { return unit === 'metric' ? a + '–' + b + ' kg' : kgToLb(a) + '–' + kgToLb(b) + ' lbs'; }
      function fmtHeight(a, b) { return unit === 'metric' ? a + '–' + b + ' cm' : cmToFtIn(a) + '–' + cmToFtIn(b); }
      function fmtLen(cm)      { return unit === 'metric' ? cm + ' cm' : cmToIn(cm) + '″'; }
      function fmtFlat(cm)     { return unit === 'metric' ? cm + ' cm' : cmToIn(cm) + '″'; }

      /* ── Table render ──────────────────────────────────── */
      function renderTable(matchLabel) {
        var rows = '';
        SIZES.forEach(function (s) {
          rows += '<tr data-size="' + s.label + '"' + (s.label === matchLabel ? ' class="is-match"' : '') + '>'
            + '<td><span class="ixsf-size">' + s.label + '</span></td>'
            + '<td>' + fmtWeight(s.wMin, s.wMax) + '</td>'
            + '<td>' + fmtHeight(s.hMin, s.hMax) + '</td>'
            + '<td>' + fmtLen(s.len) + '</td>'
            + '</tr>';
        });
        tbody.innerHTML = rows;
      }
      function renderGarment() {
        var rows = '';
        SIZES.forEach(function (s) {
          rows += '<tr><td><strong>' + s.label + '</strong></td><td>' + fmtFlat(s.waist) + '</td><td>' + fmtFlat(s.hip) + '</td><td>' + fmtFlat(s.thigh) + '</td><td>' + fmtFlat(s.len) + '</td></tr>';
        });
        gbody.innerHTML = rows;
      }

      /* ── Read inputs → kg, cm ───────────────────────────── */
      function readKg() {
        var v = parseFloat(wIn.value);
        if (!isFinite(v) || v <= 0) return null;
        return unit === 'metric' ? v : v * 0.453592;
      }
      function readCm() {
        var a = parseFloat(hA.value);
        if (unit === 'metric') return (isFinite(a) && a > 0) ? a : null;
        var b = parseFloat(hB.value); if (!isFinite(b)) b = 0;
        if (!isFinite(a) || a <= 0) return null;
        return (a * 12 + b) * 2.54;
      }

      /* ── The match ──────────────────────────────────────── */
      function recommend(kg, cm) {
        var primary, alt = null, flags = [];
        if (kg < SIZES[0].wMin) { primary = SIZES[0]; flags.push('under'); }
        else if (kg > SIZES[SIZES.length - 1].wMax) { primary = SIZES[SIZES.length - 1]; flags.push('over'); }
        else {
          var hits = SIZES.filter(function (s) { return kg >= s.wMin && kg <= s.wMax; });
          if (hits.length > 1) {
            primary = BOUNDARY_PREFERS === 'larger' ? hits[1] : hits[0];
            alt     = BOUNDARY_PREFERS === 'larger' ? hits[0] : hits[1];
          } else primary = hits[0];
        }
        if (cm !== null) {
          if (cm > primary.hMax) flags.push('tall');
          else if (cm < primary.hMin) flags.push('short');
        }
        return { primary: primary, alt: alt, flags: flags };
      }

      function describeInputs(kg, cm) {
        var w = unit === 'metric' ? Math.round(kg) + ' kg' : Math.round(kg * 2.20462) + ' lbs';
        if (cm === null) return w;
        var h = unit === 'metric' ? Math.round(cm) + ' cm' : cmToFtIn(cm);
        return h + ', ' + w;
      }

      function render() {
        var kg = readKg(), cm = readCm();
        if (kg === null) {
          out.innerHTML = '<div class="ixsf-result__empty"><p>' + "Enter your weight and we’ll match you to the chart." + '</p></div>';
          renderTable(null);
          return;
        }
        var r = recommend(kg, cm);
        var lines = '';
        if (r.alt) {
          lines += '<p class="ixsf-result__line">' + "You’re right on the line between \u003cstrong\u003e__A__\u003c\/strong\u003e and \u003cstrong\u003e__B__\u003c\/strong\u003e.".replace('__A__', r.primary.label).replace('__B__', r.alt.label) + ' '
            + (BOUNDARY_PREFERS === 'larger'
                ? "__A__ gives a closer sculpting fit; __B__ gives more ease.".replace('__A__', r.alt.label).replace('__B__', r.primary.label)
                : "__A__ gives a closer sculpting fit; __B__ gives more ease.".replace('__A__', r.primary.label).replace('__B__', r.alt.label))
            + '</p>';
        }
        if (r.flags.indexOf('under') > -1) lines += '<p class="ixsf-result__line">' + "XS is our smallest size and may fit with a little more ease than usual." + '</p>';
        if (r.flags.indexOf('over') > -1)  lines += '<p class="ixsf-result__line">' + "4XL is our largest size." + '</p>';
        if (r.flags.indexOf('tall') > -1)  lines += '<p class="ixsf-result__line">' + "You’re taller than most women in this size, so the leg may finish a touch above the ankle." + '</p>';
        if (r.flags.indexOf('short') > -1) lines += '<p class="ixsf-result__line">' + "You’re a little shorter than most women in this size, so the leg may gather slightly at the ankle." + '</p>';

        out.innerHTML =
          '<div class="ixsf-result__card">'
          + '<div class="ixsf-result__size">' + r.primary.label + '</div>'
          + '<div class="ixsf-result__text">'
          +   '<p class="ixsf-result__kicker">' + "Your size" + '</p>'
          +   '<p class="ixsf-result__basis">' + "Based on __I__".replace('__I__', describeInputs(kg, cm)) + '</p>'
          +   lines
          + '</div></div>';
        renderTable(r.primary.label);
      }

      /* ── Unit toggle: convert what's already typed ─────── */
      function setUnit(next) {
        if (next === unit) return;
        var kg = readKg(), cm = readCm();
        unit = next;
        unitsEl.setAttribute('data-unit', unit);
        try { localStorage.setItem('ixsf-unit', unit); } catch (e) {}
        overlay.querySelectorAll('.ixsf-unit').forEach(function (b) {
          var on = b.getAttribute('data-unit') === unit;
          b.classList.toggle('is-active', on); b.setAttribute('aria-selected', on ? 'true' : 'false');
        });
        overlay.querySelectorAll('.ixsf-suffix[data-imperial]').forEach(function (s) {
          s.textContent = s.getAttribute(unit === 'metric' ? 'data-metric' : 'data-imperial');
        });
        hRow.setAttribute('data-mode', unit);
        if (unit === 'metric') {
          wIn.placeholder = '64'; hA.placeholder = '160'; hA.step = '1';
          if (kg !== null) wIn.value = Math.round(kg);
          if (cm !== null) hA.value = Math.round(cm);
          hB.value = '';
        } else {
          wIn.placeholder = '140'; hA.placeholder = '5'; hB.placeholder = '3';
          if (kg !== null) wIn.value = Math.round(kg * 2.20462);
          if (cm !== null) { var t = Math.round(cm / 2.54); hA.value = Math.floor(t / 12); hB.value = t % 12; }
        }
        renderGarment();
        render();
      }

      /* ── Wire up ───────────────────────────────────────── */
      overlay.querySelectorAll('.ixsf-unit').forEach(function (b) {
        b.addEventListener('click', function () { setUnit(b.getAttribute('data-unit')); });
      });
      [wIn, hA, hB].forEach(function (el) { el.addEventListener('input', render); });

      function openModal()  { overlay.classList.add('is-open'); document.body.style.overflow = 'hidden'; setTimeout(function () { wIn.focus(); }, 60); }
      function closeModal() { overlay.classList.remove('is-open'); document.body.style.overflow = ''; }
      openBtn.addEventListener('click', openModal);
      closeBtn.addEventListener('click', closeModal);
      overlay.addEventListener('click', function (e) { if (e.target === overlay) closeModal(); });
      document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && overlay.classList.contains('is-open')) closeModal(); });

      /* Starting unit, in order: what this visitor chose last time, then the
         country Liquid resolved, then imperial. The markup ships imperial and
         setUnit flips everything before first paint if needed; nothing is
         typed yet, so there is nothing to convert. */
      var stored = null;
      try { stored = localStorage.getItem('ixsf-unit'); } catch (e) {}
      var start = (stored === 'metric' || stored === 'imperial') ? stored : overlay.getAttribute('data-default-unit');
      renderGarment();
      if (start === 'metric') setUnit('metric'); else render();
    })();

    /* confianca */
    (function(){
      // ── Geo detection ────────────────────────────────
      var fl=document.getElementById('ix-flag'),co=document.getElementById('ix-country');
      /* Country + flag are rendered server-side from Shopify Markets (localization.country); the geo-IP override was removed for the multi-market rollout. */

      // ── Size table: follow the finder's unit, open the finder ──
      var sz=document.getElementById('ix-sz'),szOpen=document.getElementById('ix-sz-open');
      function syncUnit(){
        var u=null; try{u=localStorage.getItem('ixsf-unit')}catch(e){}
        if(sz)sz.classList.toggle('ix-sz--metric',u==='metric');
      }
      syncUnit();
      document.addEventListener('click',function(e){ if(e.target.closest&&e.target.closest('.ixsf-unit'))setTimeout(syncUnit,0); });
      if(szOpen){
        var trig=document.getElementById('ixsf-open');
        if(trig){ szOpen.addEventListener('click',function(){trig.click()}); } else { szOpen.hidden=true; }
      }

      // ── Rotating social proof ticker ─────────────────
      var ticker=document.getElementById('ix-ticker');
      if(!ticker)return;

      var now=new Date();
      var hour=now.getHours();
      var day=now.getDay();
      var dayIndex=day===0?6:day-1;

      // Same weekly seed as hero
      var jan1=new Date(now.getFullYear(),0,1);
      var weekNum=Math.ceil(((now-jan1)/86400000+jan1.getDay()+1)/7);
      var seed=(weekNum*2654435761)>>>0;
      var weeklyTotal=5000+(seed%3001);

      // Hourly count (peak hours weighted)
      var dailyRate=weeklyTotal/7;
      var hourMul=(hour>=10&&hour<=22)?1.3:0.6;
      var hourly=Math.max(8,Math.round((dailyRate/24)*hourMul)+Math.round((Math.random()-0.5)*8));

      // Weekly count (cumulative, same as hero)
      var progress=(dayIndex+1)/7;
      var weeklySoFar=Math.round(weeklyTotal*progress+((Math.random()-0.5)*80));

      // Build rotating messages
      var msgs=[
        "__N__ ordered in the last hour".replace('__N__', hourly),
        "__N__+ ordered this week".replace('__N__', weeklySoFar.toLocaleString("en")),
        "\"I wish I'd found these sooner\" — most common feedback",
        "98% keep them — less than 2% return rate"
      ];

      var idx=0;
      ticker.textContent=msgs[0];

      // Rotate every 5 seconds
      setInterval(function(){
        ticker.style.opacity='0';
        setTimeout(function(){
          idx=(idx+1)%msgs.length;
          ticker.textContent=msgs[idx];
          ticker.style.opacity='1';
        },250);
      },5000);
    })();
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', ligar);
  } else {
    ligar();
  }
  var pendente = null;
  new MutationObserver(function () {
    clearTimeout(pendente);
    pendente = setTimeout(ligar, 60);
  }).observe(document.documentElement, { childList: true, subtree: true });
})();
